import { render, staticRenderFns } from "./CatalogA4.vue?vue&type=template&id=2cb75354&scoped=true"
import script from "./CatalogA4.vue?vue&type=script&lang=js"
export * from "./CatalogA4.vue?vue&type=script&lang=js"
import style0 from "./CatalogA4.vue?vue&type=style&index=0&id=2cb75354&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb75354",
  null
  
)

export default component.exports